"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const buttons_css_1 = __importDefault(require("../../../styles/global_ui/buttons.css"));
const Button = (0, react_1.forwardRef)(({ children, className, colorStyle, disabled, onClick, onKeyDown, size, style, type, buttonProps, }, ref) => {
    const classNames = [buttons_css_1.default[size], buttons_css_1.default[colorStyle], className]
        .filter((cls) => cls != null)
        .join(' ');
    return (react_1.default.createElement("button", { ref: ref, className: classNames, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, style: style, type: type, ...buttonProps }, children));
});
Button.propTypes = {
    buttonProps: prop_types_1.default.object, // any other props that the button element might need
    className: prop_types_1.default.string,
    colorStyle: prop_types_1.default.oneOf(['', 'secondary', 'tertiary', 'outline', 'outlineBlack', 'outlineBlue', 'blank', 'cancel', 'danger']),
    disabled: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    onKeyDown: prop_types_1.default.func,
    size: prop_types_1.default.oneOf(['sm', 'md', 'lg', 'jumbo']),
    style: prop_types_1.default.object,
    type: prop_types_1.default.oneOf(['button', 'submit', 'reset']),
};
Button.defaultProps = {
    buttonProps: {},
    className: '',
    colorStyle: '',
    disabled: false,
    onKeyDown: () => { },
    onClick: () => { },
    size: 'md',
    style: {},
    type: 'button',
};
Button.displayName = 'Button';
exports.default = Button;
